import handler from "./handler";
import render from "./render";

const name = "checkbox";

export default {handler, render, name};
